import { TabModel } from '../interfaces/tab-model-interface';

export const RESULT_TABS: readonly TabModel[] = [
  {
    heading: 'Insights',
    icon: 'element-trend',
    closable: false,
    active: true
  },
  {
    heading: 'Feed',
    icon: 'element-log',
    closable: false,
    active: false
  }
] as const;
